export default __webpack_public_path__ + "static/media/night-rain-active.c148011e.svg";